import { useMutation } from '@tanstack/react-query'
import { deleteReportSchedule } from 'services/TransactionExportService'

export const useDeleteReportScheduleMutation = () => {
  return useMutation({ mutationFn: deleteReportSchedule })
}
